module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.internalValue),
      expression: "internalValue"
    }],
    on: {
      "change": function($event) {
        _vm.internalValue = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2ead2690!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/atoms/eq-select/eq-select.vue
// module id = 646
// module chunks = 4